import React from 'react';

import COLORS from '../../../constants/colors.constants';
import classNames from 'classnames';

export const MemoryIcon = ({
  className = "",
  fill = COLORS.brand,
  size = 24,
  ...rest
}) => {
  return (
    <svg className={classNames(`w-${size} h-${size}`, className)} fill="none" aria-label="memory" viewBox={`0 0 24 24`} xmlSpace="preserve" {...rest}>
      <path d="M3 20V16.3H21V20H3ZM4.5 19.05H6.3V17.25H4.5V19.05ZM3 7.7V4H21V7.7H3ZM4.5 6.75H6.3V4.95H4.5V6.75ZM3 13.85V10.15H21V13.85H3ZM4.5 12.9H6.3V11.1H4.5V12.9Z" fill={fill}/>
    </svg>
  )
}

export default MemoryIcon;
